import React, { createContext } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AuthStore from "./store/authstore";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import SettingStore from "./store/settingStore";
import ModalStore from "./store/modalStore";

interface State {
  authStore: AuthStore;
  settingStore: SettingStore;
  modalStore: ModalStore;
}

export const authStore = new AuthStore();
export const settingStore = new SettingStore();
export const modalStore = new ModalStore();

export const Context = createContext<State>({
  authStore,
  settingStore,
  modalStore,
});

ReactDOM.render(
  <Context.Provider
    value={{
      authStore,
      settingStore,
      modalStore,
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Context.Provider>,
  document.getElementById("root")
);
